import {guidesCountQueryOptions} from '@blesk-frontend/api';
import {useQuery} from '@tanstack/react-query';

export const useFirstGuide = () => {
  const {data: count} = useQuery(guidesCountQueryOptions());

  const isFirstGuide = (count?.archived || 0) + (count?.unarchived || 0) === 1;

  return isFirstGuide;
};
